<tt-page>
    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListMetaTables"></tt-list>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'metatables_new'" (ttClick)="goToFunc('metatable')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-list class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListMetaTables" badge="badge" ltype="" design-var="s12t0"></tt-list>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button class="col-xs-12 sp-0" tt-text="metatables_new" tt-click="vm.goToFunc('metatable')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>
</tt-page>-->
